import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import {
  userReducer,
  loadingReducer,
  vacanciesReducer,
  showNotificationReducer,
  selectApplicantsReducer
} from "./reducer";
import { loadState } from "./utils/localstorage";

const initialState = loadState();

const configureStore = (preloadedState = initialState) => {
  const enhancers = [applyMiddleware(thunk)];

  if (process.env.NODE_ENV === "development") {
    const devToolsExtension = window.devToolsExtension;

    if (typeof devToolsExtension === "function") {
      enhancers.push(devToolsExtension());
    }
  }

  return createStore(
    combineReducers({
      user: userReducer,
      loading: loadingReducer,
      vacancies: vacanciesReducer,
      notify: showNotificationReducer,
      selectedApplicants: selectApplicantsReducer
    }),
    preloadedState,
    compose(...enhancers)
  );
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/creatStore.js